import { createContext } from "react";

// Types
type TaskStatus = "NOT-STARTED" | "IN-PROGRESS" | "IN-REVIEW" | "COMPLETED";

interface Task {
    Id: string;
    ProjectId: string;
    ParentTaskId: string | null;
    Name: string;
    Description: string;
    Status: TaskStatus;
    SortOrder: number;
    CreatedAt: string;
    UpdatedAt: string;
    ExecutionDate: string;
}

export interface TaskContextType {
    tasks: Task[] | null;
    setTasks: (tasks: Task[] | null) => void;
}

export const TaskContext = createContext<TaskContextType | undefined>(undefined);
